import React, { Component } from 'react';
import styled from 'styled-components';
import { redirect404 } from 'helpers';
import api from 'api';
import Image from 'partials/Image';
import { NavLink } from 'react-router-dom';
import NotFound from 'partials/NotFound'


class Employees extends Component {

	constructor() {
		super()
		this.state = {
			notFound: false,
			employees: [],
			employeesFromFetcher: []
		}
	}

	componentDidMount() {
		this.mounted = true;
		this._loadPageFromSlug();
		this._loadEmployeesFromFetcher();
	}

	componentWillUnmount() {
		this.mounted = false;
	}


	_loadPageFromSlug = async () => {
		await api.getPageBySlug(this.props.page.slug).then(response => {
			if(!response.data[0]) {
				this.setState({ notFound: true })
			}
			if(this.mounted) {
				const modules = response.data[0].acf.modules;
				const employees = modules.find(item => item.acf_fc_layout == 'employees').employees;
				this.setState({ employees: employees });
			}
		});
	}

	_loadEmployeesFromFetcher = async () => {
		await api.employeesFetcher.getAll().then(response => {
			const employeesFromFetcher = response.data;
			const { employees } = this.state;
			const filteredEmployees = employees.map((employee) => {
				return employeesFromFetcher.find(item => item.id == employee.ID);
			})
			this.setState({ employeesFromFetcher: filteredEmployees });
		});
	}

	render() {
		const { employees, employeesFromFetcher } = this.state;

		if(this.state.notFound) return <NotFound/>

		return(
			<Container>
				{ employeesFromFetcher.map((employee, index) => (
					<Employee>
						<Image maxHeight="150" image={employee.acf.image} className="image" background ratio="1:1" />
						<div className="contactInformation">
							<div className="title"><a className="term-link" href={employee.link} >{employee.acf.name}</a></div>
							<div className="role">{employee.acf.role}</div>
								<div className="phonenumber">{employee.acf.phone}</div>
								<div className="email">{employee.acf.email}</div>
						</div>
					</Employee>
				))}
			</Container>
		)
	}
}

const Container = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	max-width: 960px;
	margin: 0 auto;
	padding-bottom: 60px;
`;

const Employee = styled.div`
	position: relative;
	flex: 0 0 50%;
	padding-bottom: 60px;

	.image {
		float: left;
		width: 30%;
	}

	.contactInformation {
		padding-left: 35%;
		font-family: Helvetica;
		font-size: 16px;
		color: #002857;
		line-height: 24px;

		.title {
			font-size: 24px;
			line-height: 34px;
			text-decoration: underline;
			padding-bottom: 5px;
		}

		.role {
			padding-bottom: 5px;
		}

		.phonenumber {
			padding-bottom: 5px;
		}
	}

	@media(max-width: 1024px) {
		padding-left: 30px;
	}

	@media(max-width: 480px) {
		flex: 0 0 100%;
		padding-left: 20px;
	}
`;


export default Employees;


// WEBPACK FOOTER //
// ./src/partials/modules/Employees/Employees.js